import React, { useState, useEffect } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email.trim().toLowerCase(), password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-brand-cream text-brand-green">Loading…</div>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8">
          <div className="w-10 h-10 rounded-full bg-brand-green flex items-center justify-center text-brand-gold font-serif text-xl">K</div>
          <div className="font-serif text-xl text-brand-green">KBX Admin</div>
        </Link>
        <div className="bg-white border border-brand-green/10 rounded-2xl p-8 shadow-sm">
          <div className="text-xs tracking-[0.25em] uppercase text-brand-sage">Restricted Access</div>
          <h1 className="font-serif text-3xl text-brand-green mt-2">Sign in</h1>
          <p className="text-slate-600 text-sm mt-1">Access the submission dashboard.</p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
            </div>
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center bg-brand-green text-white rounded-full px-6 py-3 text-sm font-medium hover:bg-brand-navy transition-colors disabled:opacity-60"
            >
              {submitting ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
        <div className="text-center mt-6">
          <Link to="/" className="text-sm text-slate-500 hover:text-brand-green">← Back to site</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
